export const environment = {
  production: true,
  apiUrl: "https://hocnhomapi.kasoft.vn/api",
  private: true,
  syncLive: false,
  schoolId: "AEF5EBC9-11AF-46B1-B1C7-99C25DB92A3D",
  visibility: "public",
  logoUrl: "/assets/images/samedtech.png",
  regionLocation: "asia-southeast1",
  functionsUrl: "https://asia-southeast1-kasoft-samedtech.cloudfunctions.net/",
  firebase: {
    apiKey: "AIzaSyCRoGivQkGYcUHOIpXjvvqpl2JMFv95-qQ",
    authDomain: "kasoft-samedtech.firebaseapp.com",
    databaseURL:
      "https://kasoft-samedtech-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "kasoft-samedtech",
    storageBucket: "kasoft-samedtech.firebasestorage.app",
    messagingSenderId: "138950548745",
    appId: "1:138950548745:web:972fc8d8de928dd07647d8",
    measurementId: "G-8KDWYLVRHK",
  },
  recaptcha: "6LfUBugsAAAAAGADBV35nE-sGe1jqP-nrxTVbm_R",
  imageKit: {
    publicKey: "public_LGFaPuvRvxAC08h5DJWOcsI+BH8=",
    urlEndpoint: "https://ik.imagekit.io/kasoft",
    authenticationEndpoint:
      "https://asia-southeast1-kasoft-samedtech.cloudfunctions.net/imagekit-auth",
    urlServer: "https://upload.imagekit.io/api/v1/files/upload",
  },
};
